import { createSlice } from "@reduxjs/toolkit";
import { steps } from "../../../constants";

const initialState = {
  activeStep: 0,
  completed: {},
};

export const totalSteps = (steps) => {
  return steps?.length;
};

export const isLastStep = (steps, activeStep) => {
  return activeStep === totalSteps(steps) - 1;
};

export const completedSteps = (completed) => {
  if (completed) {
    return Object.keys(completed)?.length;
  } else {
    return;
  }
};

export const allStepsCompleted = (steps, completed) => {
  return completedSteps(completed) === totalSteps(steps);
};

export const addNewContentStepsSlice = createSlice({
  name: "addNewContentSteps",
  initialState,
  reducers: {
    handleNext: (state, action) => {
      const newActiveStep =
        isLastStep(steps, state.activeStep) &&
        !allStepsCompleted(steps, state.completed)
          ? steps.findIndex((step, i) => !(i in state.completed))
          : state.activeStep + 1;
      state.activeStep = newActiveStep;
    },
    handleBack: (state, action) => {
      state.activeStep = state.activeStep - 1;
    },
    handleStep: (state, action) => {
      state.activeStep = action.payload;
    },
    handleComplete: (state, action) => {
      state.completed[state.activeStep] = true;
      addNewContentStepsSlice.caseReducers.handleNext(state, action);
    },
    handleCompleteStep: (state, action) => {
      state.completed[action.payload] = true;
      addNewContentStepsSlice.caseReducers.handleNext(state, action);
      state.activeStep = action.payload + 1;
    },
    handleReset: (state, action) => {
      state.activeStep = 0;
      state.completed = {};
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  handleNext,
  handleBack,
  handleStep,
  handleComplete,
  handleReset,
  handleCompleteStep,
} = addNewContentStepsSlice.actions;

export default addNewContentStepsSlice.reducer;
